import styled from "@emotion/styled";
import {Box, css} from "@mui/material";
import {media} from "assets/css/media";

export const EmptySlot = styled(Box)`
	position: relative;
	width: 100%;
	max-height: 88px;
	min-height: 86px;
	background: var(--thirdColor);
	box-shadow: 0 0 2px rgba(28, 28, 30, 0.2);
	border-radius: 8px;
	display: flex;
	margin-bottom: 16px;
	overflow: hidden;
	padding: 0 4px;

	@media (max-width: ${media.mobile}) {
		margin-bottom: 6px;
		max-height: 66px;
		min-height: 66px;
	}
`;
export const FilledSlot = styled(EmptySlot)`
	min-height: 86px;
	background: #fff;
	padding: 4px;

	@media (max-width: ${media.mobile}) {
		margin-bottom: 6px;
		max-height: 66px;
		min-height: 66px;
	}
`;

export const PlayerSlotName = styled(Box)`
	font-family: var(--fontFamilySecond);
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 140%;
	display: flex;
	align-items: center;
	text-transform: capitalize;
	color: var(--thirdColor);

	span {
		margin-right: 5px;
	}
`;

export const SavedSlot = styled(Box)`
	border: 2px solid #ffffff;
	box-shadow: 0 1px 2px rgba(28, 28, 30, 0.1), 0px 8px 16px rgba(28, 28, 30, 0.2);
	border-radius: 8px;

	position: relative;
	overflow: hidden;
	height: 168px;

	@media (max-width: ${media.mobile}) {
		height: 120px;
	}

	img {
		display: block;
		margin: 0 auto;
		width: 75%;
	}
`;
export const SavedSlotName = styled(Box)`
	position: absolute;
	//position: relative;
	bottom: 0;
	width: 100%;
	padding: 6px 0;
	box-sizing: border-box;

	background: #fff;

	font-family: var(--fontFamilySecond);
	font-style: normal;
	font-weight: 325;
	font-size: 12px;
	line-height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	letter-spacing: 0.2px;
	text-transform: capitalize;
	flex-direction: column;

	color: var(--thirdColor);

	@media (max-width: ${media.mobile}) {
		padding: 5px 0;
		//position: relative;
	}

	p {
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		letter-spacing: 0.2px;
		text-transform: capitalize;

		&.bold {
			font-weight: 500;
			text-transform: uppercase;
		}
	}
`;
export const Note = styled(Box)`
	background: transparent;
	border-radius: 0 8px 0 0;
	padding: 8px 4px;
	font-family: var(--fontFamilySecond);
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 1.1;
	display: flex;
	align-items: center;
	text-align: center;
	color: #ffffff;

	position: absolute;
	top: 9px;
	left: -8px;
	transform: rotate(-90deg);

	@media (max-width: ${media.mobile}) {
		padding: 3px 5px;
		font-size: 8px;
	}
`;

// ------------------------------

type ClickableProps = {
	_clickable?: boolean;
};

export const PlayerSlotWrapper = styled.label<ClickableProps>`
	border-radius: 10px;
	padding: 4px 12px 4px 4px;
	background: #fff;
	border: 1px solid #e8e8e8;
	display: flex;
	align-items: center;
	width: 100%;
	gap: 16px;
	cursor: ${({_clickable}) => (_clickable ? "pointer" : "default")};

	label& {
		cursor: pointer;
	}
`;

type IPlayerSlotImageWrapper = {
	_widerImg?: boolean;
};

const cssPlayerSlotImageWrapperWiderImg = ({_widerImg}: IPlayerSlotImageWrapper) =>
	_widerImg &&
	css`
		min-width: var(--playerSlotImageWidth);
	`;

export const PlayerSlotImageWrapper = styled.div<IPlayerSlotImageWrapper>`
	display: flex;
	${cssPlayerSlotImageWrapperWiderImg};
`;

export const PlayerSlotImage = styled.div<{withPlayer?: boolean}>`
	display: flex;
	height: 60px;
	justify-content: center;
	align-items: ${({withPlayer}) => (withPlayer ? "flex-start" : "flex-end")};
	background: #9da8bb;
	border-radius: 8px;
	overflow: hidden;

	.small & {
		height: 40px;
	}

	&.europe {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #0076EB 0%, #003C82 100%)" : "#9da8bb"};
	}

	&.usa {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #FB4D56 0%, #FF0019 100%)" : "#9da8bb"};
	}

	img {
		display: block;
		width: 100%;
		max-width: 58px;

		.small & {
			max-width: 40px;
		}
	}

	img:first-of-type {
		z-index: 5;
	}

	img + img {
		margin-left: -20px;

		.small & {
			margin-left: -10px;
		}
	}
`;

export const PlayerSlotImageSmall = styled(PlayerSlotImage)`
	height: 40px;
`;

export const PlayerSlotInfo = styled.div`
	flex-grow: 1;
	font-size: 14px;
	line-height: 130%;
	text-transform: uppercase;
	color: var(--thirdColor);
`;

export const PlayerSlotInfoStrong = styled.span`
	font-family: var(--fontFamilySecond);
	font-weight: 500;
`;

export const PlayerSlotAction = styled.div``;

export const PlayerInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const PlayerInfoStyled = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const PlayerName = styled.div`
	display: flex;
	flex-grow: 1;
	gap: 6px;
	font-size: 14px;
	line-height: 130%;
`;

export const PlayerNameBold = styled.div`
	font-weight: 500;
	font-family: var(--fontFamilySecond);
`;

export const PickSelectIcon = styled.div`
	flex-shrink: 0;
	background: #011536;
	width: 56px;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
`;

export const PickSelectIconSmall = styled(PickSelectIcon)`
	width: 40px;
	height: 40px;
`;

export const NotPlaying = styled.div`
	text-transform: none;
	margin-top: 3px;

	.small & {
		margin-top: 0;
	}
`;
